import React, { useEffect, useRef, useState } from "react";

import gris from "../img/gris.png";
import estilo from "./styles/Carrusel.module.css";
// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
// import required modules
import { Autoplay } from "swiper";
import { Link } from "react-router-dom";

function Carrusel({ lista }) {
  const swiperRef = useRef();

  function previo() {
    swiperRef.current?.slidePrev();
  }

  function siguiente() {
    swiperRef.current?.slideNext();
  }

  const [load, setLoad] = useState(false);

  useEffect(() => {
    setLoad(true);
  }, []);

  return (
    <Swiper
      slidesPerView={4}
      spaceBetween={20}
      centeredSlides={false}
      loop={true}
      autoplay={{
        delay: 4000,
        disableOnInteraction: false,
      }}
      pagination={{
        clickable: false,
      }}
      speed={450}
      breakpoints={{
        0: {
          slidesPerView: 2,
        },
        576: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 4,
        },
        960: {
          slidesPerView: 5,
        },
        1200: {
          slidesPerView: 6,
        },
      }}
      onBeforeInit={(swiper) => {
        swiperRef.current = swiper;
      }}
      modules={[Autoplay]}
      className={estilo.swiper}
    >
      {lista.map((e, i) => (
        <SwiperSlide key={i}>
          <Link to={"/" + e.uid}>
            <div className={estilo.tarjetas}>
              {load ? (
                <img src={e.portada} alt={e.nombre} />
              ) : (
                <img src={gris} alt="imagen de carga" />
              )}
            </div>
            <div className={estilo.datos}>
              <p>{e.nombre}</p>
              <p>{e.año}</p>
            </div>
          </Link>
        </SwiperSlide>
      ))}
      <div>
        <button className={estilo.botonP} onClick={previo}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            fill="currentColor"
            viewBox="0 0 16 16"
          >
            <path d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z" />
          </svg>
        </button>
        <button className={estilo.botonN} onClick={siguiente}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="30"
            height="30"
            fill="currentColor"
            viewBox="0 0 16 16"
          >
            <path d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z" />
          </svg>
        </button>
      </div>
    </Swiper>
  );
}

export default Carrusel;
